import { Currency } from "interfaces/currency";
import { createContext } from "react";

export const CurrencyContext = createContext<{ currency: { currency: Currency, exchangeRate: number }, setCurrency: (args: { currency: Currency, exchangeRate: number }) => void } | null>(null);
